import {ref, readonly} from 'vue';
import ApiService from '@/services/api/apiService';

export type AppSettings = {
    forceUpdate?: boolean;
    version?: string;
    build?: number;
    isMaintenance?: boolean;
    enableNsfw?: boolean;
    enableEvents?: boolean;
    enableGallery?: boolean;
    iosUrl?: string;
    androidUrl?: string;
    [key: string]: unknown;
};

const settings = ref<AppSettings>({
    enableNsfw: true,
    enableEvents: true,
    enableGallery: true,
    isMaintenance: false,
    forceUpdate: false,
});

const loaded = ref(false);
const sleepMode = ref(false);

export function useAppSettings() {
    return {
        settings: readonly(settings),
        loaded: readonly(loaded),
        sleepMode: readonly(sleepMode),
        setSleepMode(value: boolean) {
            sleepMode.value = value;
        },
        async load(force = false) {
            if (loaded.value && !force) return settings.value;
            try {
                const data = await ApiService.Settings().appSettings();
                settings.value = {
                    enableNsfw: data?.enableNsfw !== false,
                    enableEvents: data?.enableEvents !== false,
                    enableGallery: data?.enableGallery !== false,
                    isMaintenance: Boolean(data?.isMaintenance),
                    forceUpdate: Boolean(data?.forceUpdate),
                    version: data?.version,
                    build: data?.build,
                    iosUrl: data?.iosUrl,
                    androidUrl: data?.androidUrl,
                    ...data,
                };
                loaded.value = true;
            } catch {
                loaded.value = true;
            }
            return settings.value;
        },
    };
}
